import { render, staticRenderFns } from "./CreateupdateCustomer.vue?vue&type=template&id=513ddb0e&scoped=true&"
import script from "./CreateupdateCustomer.vue?vue&type=script&lang=js&"
export * from "./CreateupdateCustomer.vue?vue&type=script&lang=js&"
import style0 from "./CreateupdateCustomer.vue?vue&type=style&index=0&id=513ddb0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513ddb0e",
  null
  
)

export default component.exports